import React from "react";
import { css } from "@emotion/react";
import { SwarovskiButton } from "../../../components/_shared-components/ui-elements/SwarovskiButton";
import { FONTS, fontSize } from "../../../styles/fonts";

export const ErrorView: React.FC<{ pathname: string; errorMessage: string; buttonLabel: string }> = ({
  pathname,
  errorMessage,
  buttonLabel,
}) => {
  return (
    <div
      className="u-flex u-flex-col u-items-center u-jc-center"
      css={[
        FONTS.SwarovskiFutura300,
        fontSize.x3,
        css`
          margin-top: 50px;
          margin-bottom: 50px;
        `,
      ]}
    >
      <p className="u-mb-5">{errorMessage}</p>

      <SwarovskiButton as={"a"} link={pathname} isInternal={false} variant="green">
        {buttonLabel}
      </SwarovskiButton>
    </div>
  );
};
